export const ITEM_TYPE = 'ITEM_TYPE' as const;

export const CHILD_ITEM_TYPE = 'CHILD_ITEM_TYPE' as const;
